import { FontIcon, Link, PrimaryButton, TextField } from 'office-ui-fabric-react';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import * as React from 'react';
import { Redirect } from 'react-router';
import { IModalDialog } from '../../../models/IModalDialog';
import { IToken } from '../../../models/IToken';
import ConnectionContext from '../../../utils/ConnectionContext';
import "../captcha.css";
import { ILoginProps } from './ILoginProps';
import { ILoginState } from './ILoginState';
initializeIcons();

const getStyles = () => {
    return {
        root: {
            maxWidth: '300px',
            responsiveMode: true,
            color: '#005269'
        }
    }
};
const panel = mergeStyles({
    alignContent: "center",
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '100px',
    padding: '10px',
    minWidth: '200px',
    width: "100%", fontSize: "13px", color: '#005269'
});
const captchaVisible = mergeStyles({
    paddingTop: "20px", overflowX: "auto", overflowY: "hidden"
});
const captchaInvisible = mergeStyles({
    display: "none"
});
const topMsgPanel = mergeStyles({
    textAlign: "center", backgroundColor: "#006d79", color: "#FFFFFF", width: "100%", padding: "5px"
});
const errorMsgPanel = mergeStyles({
    color: '#E9512D', fontSize: "13px", textAlign: "center"
});
const iconPanel = mergeStyles({
    paddingRight: "3px"
});
const topPanel = mergeStyles({
    justifyContent: "center", width: "100%", display: "flex", padding: "10px"
});
const submitButton = mergeStyles({ backgroundColor: '#F39000', marginRight: "5px" });
export default class Login extends React.Component<ILoginProps, ILoginState>
{
    private connectionContext: ConnectionContext;
    private username: string;
    private password: string;
    private saving: boolean = false;
    private dialog: IModalDialog;
    private recaptchaError: string;

    constructor(props: ILoginProps, state: ILoginState) {
        super(props);
        this.username = '';
        this.password = '';
        this.connectionContext = this.props.connectionContext;
        this.recaptchaError = '';
        this.dialog = {
            hideDialog: true,
            accessDeniedDialog: false,
            dialogMessage: '',
            dialogBody: '',
            mode: ''
        }
        this.state = {
            loading: false,
            inputError: '',
            showError: false,
            isValidData: false,
            isAgent: false,
            isAdmin: false,
            emailError: '',
            passwordError: '',
            siteKey: "",
            captchaVisible: false,
            captchaToken: ""
        }
        window['getCaptchaResponse'] = this.getCaptchaResponse;
    }
    private onloadCallback() {
        try {
            if (this.state.siteKey) {
                window['grecaptcha'].render('recaptchaLogin', {
                    'sitekey': this.state.siteKey,
                    'callback': this.getCaptchaResponse,
                    'theme': 'light'
                });
            }
        } catch (exception) {
            this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
        }
    }
    public async componentDidMount() {
        await this.loadSiteKey();
        this.onloadCallback();
    }
    public render(): React.ReactElement<ILoginProps> {
        const { isAdmin, isAgent, siteKey } = this.state;
        if (isAgent)
            return <Redirect to={'../Dashboard/AgentDashboard'} />;

        if (isAdmin)
            return <Redirect to={'../../Admin/Dashboard/AdminDashboard'} />;
        return (
            <div className={panel}>
                {
                    <div className={topMsgPanel}>
                        <h4><FontIcon iconName="Group" className={iconPanel} />Welcome to Zacco's agent network</h4>
                    </div>
                }
                {
                    (this.saving && this.state.showError) && (
                        <div>
                            <div>
                                <p className={errorMsgPanel}> <FontIcon iconName="Error" className={iconPanel} />Invalid email address or password.</p>
                            </div>
                        </div>)
                }
                {
                    ((!this.saving || this.state.showError) && siteKey) && (
                        <div className={topPanel}>
                            <div>
                                <div>
                                    <TextField label="Email address" required placeholder="Email address" styles={getStyles} onBlur={this.getErrorMessageEMValid}
                                        maxLength={40} onChange={this.onChangeUsername} errorMessage={this.state.emailError} onKeyDown={this.onEnter}
                                        iconProps={{ iconName: 'PublicEmail' }} />
                                </div>
                                <div>
                                    <TextField label="Password" required placeholder="Password" styles={getStyles} maxLength={40} type="password" onBlur={this.getErrorMessagePSValid}
                                        onChange={this.onChangePassword} errorMessage={this.state.passwordError} onKeyDown={this.onEnter}
                                        iconProps={{ iconName: 'Lock' }} />
                                </div>
                                <div className={this.state.captchaVisible ? captchaVisible : captchaInvisible}>
                                    <div id="recaptchaLogin">
                                    </div>
                                    <div>
                                        <span className={errorMsgPanel}>{this.recaptchaError}</span>
                                    </div>
                                </div>
                                <div className={captchaVisible}>
                                    <PrimaryButton text="Login" data-automation-id="test" onClick={this.submitForm} className={submitButton}
                                        iconProps={{ iconName: 'Signout' }} />
                                    <Link href="../User/ResetPassword/ResetPassword">Forgot password?</Link>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
        );
    }
    private loadSiteKey = async (): Promise<void> => {
        try {
            let siteKey: string = await this.props.connectionContext.get("Login/captchakey");
            this.setState((prevState: ILoginState): ILoginState => {
                prevState.siteKey = siteKey;
                return prevState;
            });
        } catch (exception) {
            this.setState((prevState: ILoginState): ILoginState => {
                prevState.isValidData = false;
                prevState.siteKey = "";
                this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
                return prevState;
            });
        }
    }
    private getCaptchaResponse = async (token: string) => {
        if (token) {
            this.setState((prevState: ILoginState): ILoginState => {
                prevState.captchaToken = token;
                this.recaptchaError = '';
                return prevState;
            });
        }
    }
    private setCaptchaVisiblity = async (): Promise<void> => {
        try {
            let captchaVisibility: boolean = await this.props.connectionContext.get(`Login/${this.username}/captchavisible`);
            this.setState((prevState: ILoginState): ILoginState => {
                prevState.captchaVisible = captchaVisibility;
                return prevState;
            });
        } catch (exception) {
            this.setState((prevState: ILoginState): ILoginState => {
                prevState.captchaVisible = false;
                this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
                return prevState;
            });
        }
    }
    private getErrorMessageEMValid = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ILoginState): ILoginState => {
            let newValue = this.username || '';
            const re = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
            if (!re.test(newValue)) {
                prevState.emailError = 'Enter a valid Email address';
            }
            else {
                prevState.emailError = '';
            }
            return prevState;
        });
    }
    private onChangeUsername = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ILoginState): ILoginState => {
            let newValue = value || '';
            if (newValue.length < 1) {
                prevState.emailError = 'Email address is Required.';
                this.username = '';
            }
            else {
                prevState.emailError = '';
                this.username = newValue;
            }
            return prevState;
        });
    }
    private onChangePassword = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ILoginState): ILoginState => {
            let newValue = value || '';
            if (newValue.length < 1) {
                prevState.passwordError = 'Password is Required.';
                this.password = '';
            }
            else {
                prevState.passwordError = '';
                this.password = newValue;
            }
            return prevState;
        });
    }
    private getErrorMessagePSValid = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ILoginState): ILoginState => {
            let newValue = this.password || '';
            const re = /^[a-zA-Z0-9~!@#$%^&*()\b]+$/;
            if (!re.test(newValue)) {
                prevState.passwordError = 'Allowed characters: a-z, A-Z, 0-9 and special characters like ~!@#$%^&*()';
            }
            else {
                prevState.passwordError = '';
            }
            return prevState;
        });
    }
    private submitForm = async (): Promise<void> => {
        if (this.checkMandatoryFields()) {
            try {
                let authenticated: boolean = await this.connectionContext.login(this.username, this.password, this.state.captchaToken);
                if (authenticated) {
                    let tokenInformation: IToken | null = this.props.connectionContext.getCurrentUserInformation();

                    this.setState((prevState: ILoginState): ILoginState => {
                        prevState.isValidData = true;
                        prevState.showError = false;
                        if (tokenInformation !== null) {
                            prevState.isAgent = tokenInformation.userType === "0";
                            prevState.isAdmin = tokenInformation.userType === "1";
                        } else {
                            prevState.isAgent = false;
                            prevState.isAdmin = false;
                        }
                        prevState.captchaVisible = false;
                        return prevState;
                    });
                    this.props.onAuthentication();
                } else {
                    this.saving = true;
                    this.setState((prevState: ILoginState): ILoginState => {
                        prevState.isValidData = false;
                        prevState.showError = true;
                        prevState.isAdmin = false;
                        prevState.isAgent = false;
                        prevState.captchaVisible = false;
                        return prevState;
                    });
                }
            } catch (exception) {
                if (exception == 401) {
                    this.setState((prevState: ILoginState): ILoginState => {
                        prevState.isValidData = false;
                        prevState.showError = true;
                        prevState.isAdmin = false;
                        prevState.isAgent = false;
                        return prevState;
                    });
                }
                else {
                    this.setState((prevState: ILoginState): ILoginState => {
                        prevState.isValidData = false;
                        prevState.showError = true;
                        prevState.isAdmin = false;
                        prevState.isAgent = false;
                        this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
                        return prevState;
                    });
                }
            }
        }
        await this.setCaptchaVisiblity();
    }
    private checkMandatoryFields(): boolean {

        let validState: boolean = true;
        let emailEntered: boolean = this.username.trim().length > 0;
        let passwordEntered: boolean = this.password.trim().length > 0;
        let captchatoken: boolean = this.state.captchaToken.toString().trim().length > 0;

        if (!emailEntered) {
            this.setState({ emailError: 'Email address is Required' });
            validState = false;
        }
        if (!passwordEntered) {
            this.setState({ passwordError: 'Password is Required' });
            validState = false;
        }
        if (this.state.captchaVisible && !captchatoken) {
            this.recaptchaError = 'Invalid captcha';
            validState = false;
        }
        else {
            this.recaptchaError = '';
        }
        this.setState((prevState: ILoginState): ILoginState => {
            prevState.isValidData = validState;
            return prevState;
        });
        return validState;
    }
    private handleError(message: string, body: string) {
        this.dialog.dialogMessage = message;
        this.dialog.dialogBody = body;
        this.dialog.accessDeniedDialog = false;
        this.dialog.hideDialog = false;
        this.setState((previousState: ILoginState, props: ILoginProps): ILoginState => {
            previousState.isValidData = false;
            return previousState;
        });
    }
    private onEnter = (e) => {
        let keyCode = e.keyCode;
        if (keyCode === 13) {
            this.submitForm();
        }
    }
}